import axios from 'axios';

// Utility to create Axios instances with default headers
const createAxiosInstance = (contentType: string) => {
  const apiKey =  process.env.REACT_APP_API_KEY
  const instance = axios.create({
    baseURL:  process.env.REACT_APP_ENTERPRISE_BACKEND_URL,
    
    // timeout: 10000,
    headers: {
      'Content-Type': contentType,
      'x-api-key': apiKey,
    },
  });
  //  console.log("baseURL159", process.env.REACT_APP_ENTERPRISE_BACKEND_URL)
  instance.interceptors.request.use(
    async config => {
      // Preserve any manually set Authorization header
      if (!config.headers.Authorization) {
        const token = await localStorage.getItem("objectId");
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
      }
      return config;
    },
    error => Promise.reject(error),
  );

  return instance;
};

// Attach response interceptors to handle errors globally
const attachResponseInterceptors = (instance: any) => {
  instance.interceptors.response.use(
    (response: any) => response,
    (error: any) => {
      console.error('API Error:', error);

      const responseError = error?.response?.data || error?.response;

      // const responseError = error.response.data;

      console.error('API Error:', responseError);
      return Promise.reject(responseError);
    },
  );
};

export const API = createAxiosInstance('application/json');
export const APIFORMDATA = createAxiosInstance('multipart/form-data');

[API, APIFORMDATA].forEach(attachResponseInterceptors);
